



























































import { Vue, Component } from "vue-property-decorator";
import { getCurrentCompanyId } from "@/plugins/roles";
import SelectEntity from "@/components/form/SelectEntity.vue";
import CustomButton from "@/components/form/CustomButton.vue";
import CustomTable from "@/components/form/CustomTable.vue";
import CPage from "@/components/form/CustomPage/CPage.vue";
import CField from "@/components/form/CField.vue";
import CBlock from "@/components/form/CustomPage/CBlock.vue";
import { documentGeneratorApi } from "@/getinfo-api";
import { TemplateFile as ITemplateFile } from "@/api-v2/document-generator/models/template-file";
import DocTemplateListItem from "@/components/doc-tempates/DocTemplateListItem.vue";

@Component({
  components: {
    DocTemplateListItem,
    CBlock,
    CField,
    CPage,
    CustomTable,
    SelectEntity,
    CustomButton
  }
})
export default class DocTemplates extends Vue {
  type:
    | "act"
    | "bill"
    | "contract"
    | "education-protocol"
    | "enrollment-order"
    | "expulsion-order"
    | "final-document" = "act";
  templates: ITemplateFile[] = [];
  isLoading: boolean = false;

  get selectedCompany() {
    return getCurrentCompanyId();
  }

  onDeleteTemplate(id: string) {
    this.templates = this.templates?.filter(el => el.id !== id);
  }

  onUpdateTemplate(template: ITemplateFile) {
    this.templates = this.templates?.map(o => {
      if (o.id === template.id) {
        return template;
      }
      return o;
    });
  }

  onAddTemplateToList(value: { id: string; newTemplate: ITemplateFile }) {
    this.templates?.unshift(value.newTemplate);
    this.templates = this.templates?.filter(el => el.id !== value.id);
  }

  async getDocumentTemplates() {
    try {
      this.isLoading = true;
      const {
        data
      } = await documentGeneratorApi.TemplateFiles.listTemplateFiles(
        this.selectedCompany,
        this.type
      );

      this.templates = data;
    } catch (e) {
      await this.$store.dispatch("errorException", {
        vm: this,
        error: e.response
      });
    } finally {
      this.isLoading = false;
    }
  }

  async created() {
    await this.getDocumentTemplates();
  }
}
